import React from "react";
import { Center, Heading } from "@chakra-ui/react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { FcGraduationCap } from "react-icons/fc";
import { MdWork } from "react-icons/md";

export const Education = () => {
  return (
    <section className="education profile pt-5 heading" id="education">
      <Center>
        <Heading textAlign={"center"}>
          My
          <span style={{ color: "rgb(220, 20, 60)" }}> Education </span> And
          <span style={{ color: "rgb(220, 20, 60)" }}> Experience </span>
          Section
        </Heading>
      </Center>

      <VerticalTimeline>
        {/* TokenMetrics */}
        <VerticalTimelineElement
          date={"Oct 2022 - Present"}
          className="vertical-timeline-element--work"
          contentStyle={{
            background: "#fff",
            color: "black",
            border: "2px solid #dd143c",
          }}
          contentArrowStyle={{ borderRight: "7px solid  #dd143c" }}
          iconStyle={{ background: "#dd143c", color: "#fff" }}
          icon={<MdWork />}
        >
          <h3 className="vertical-timeline-element-title">
            <strong>Full Stack Developer</strong>
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            Token Metrics (Cryptocurrency Research Platform) <span style={{ color: "rgb(220, 20, 60)", fontWeight:600 }} >WFH</span> 
          </h4>
          <p>
            API Development & Performance Improvement
            <a
              href="https://developers.tokenmetrics.com/reference/tokens"
              target="_black"
              style={{ color: "rgb(220, 20, 60)" }}
            >
            &nbsp;  link
            </a>
            <br />
            Create & Handle API Docs
            <br />
            Work on Platform Improvement
            <br />
            Sonarqube Code Quality For All Products
            <br />
          </p>
          <p>
            60+ Ticket resoled
            <br />
            850+ Security Hotspots Bug resoled
          </p>
        </VerticalTimelineElement>

        {/* Masai School */}
        <VerticalTimelineElement
          date={"Jan 2022 - Sep 2022"}
          className="vertical-timeline-element--work"
          contentStyle={{ background: "#fff", color: "black" }}
          iconStyle={{ background: "rgb(233, 30, 99)", color: "#fff" }}
          icon={<FcGraduationCap />}
        >
          <h3 className="vertical-timeline-element-title">
            <strong>MERN Stack Developer</strong>
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            Masai School (Online)
          </h4>
          <p>
            Joined the Military style Bootcamp to learn Full Stack Development
            Development and Data Structures.
          </p>
          <p>
            100+ Mini Project
            <br />
            5+ Trem Project
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2020"
          iconStyle={{ background: "rgb(233, 30, 99)", color: "#fff" }}
          icon={<MdWork />}
        >
          <h3 className="vertical-timeline-element-title">
            <strong>Frontend Developer</strong>
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            Business Alliance (Digital Marketing Agency) <span style={{ color: "rgb(220, 20, 60)", fontWeight:600 }} >WFO</span>
          </h4>
          <p>
            Create a creative website according to the client's requirements
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          date="2020"
          iconStyle={{ background: "rgb(233, 30, 99)", color: "#fff" }}
          icon={<FcGraduationCap />}
        >
          <h3 className="vertical-timeline-element-title">
            <strong>Bacherlor Of Computer Application</strong>
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            Sardha College Ahmednagar
          </h4>
          <p>
            University of Pune
            <br />
            CGPA 7.5
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="2015"
          iconStyle={{ background: "rgb(233, 30, 99)", color: "#fff" }}
          icon={<FcGraduationCap />}
        >
          <h3 className="vertical-timeline-element-title">
            <strong>HSC (Science)</strong>
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            New Arts College Ahmednagar
          </h4>
          <p>University of Pune</p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="2013"
          iconStyle={{ background: "rgb(233, 30, 99)", color: "#fff" }}
          icon={<FcGraduationCap />}
        >
          <h3 className="vertical-timeline-element-title">
            <strong>Adv Diploma in Hardware & Networking</strong>
          </h3>
          <h4 className="vertical-timeline-element-subtitle">IANT</h4>
          <p>
            Practical skills in assembling the computer's hardware components
            etc..
            <br />
            The Config switches, routers, and wireless access points. Switches,
            routers, and wireless access points are the essential networking
            basics
          </p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--education"
          date="2013"
          iconStyle={{ background: "rgb(233, 30, 99)", color: "#fff" }}
          icon={<FcGraduationCap />}
        >
          <h3 className="vertical-timeline-element-title">
            <strong>SSC</strong>
          </h3>
          <h4 className="vertical-timeline-element-subtitle">
            K.G.H High School Ahmednagar
          </h4>
          <p>Univercity of Pune</p>
        </VerticalTimelineElement>
      </VerticalTimeline>
    </section>
  );
};
